// extracted by mini-css-extract-plugin
export default {"navLinkSubMenu":"NavItemSubMenu_navLinkSubMenu__agAON","disabled":"NavItemSubMenu_disabled__+BR2A"};